/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SafeSize } from './SafeSize';
import {
    SafeSizeFromJSON,
    SafeSizeFromJSONTyped,
    SafeSizeToJSON,
    SafeSizeToJSONTyped,
} from './SafeSize';

/**
 * 
 * @export
 * @interface SafeDepositBoxSafeSizeOption
 */
export interface SafeDepositBoxSafeSizeOption {
    /**
     * 
     * @type {SafeSize}
     * @memberof SafeDepositBoxSafeSizeOption
     */
    value: SafeSize;
    /**
     * 
     * @type {string}
     * @memberof SafeDepositBoxSafeSizeOption
     */
    label: string;
}



/**
 * Check if a given object implements the SafeDepositBoxSafeSizeOption interface.
 */
export function instanceOfSafeDepositBoxSafeSizeOption(value: object): value is SafeDepositBoxSafeSizeOption {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SafeDepositBoxSafeSizeOptionFromJSON(json: any): SafeDepositBoxSafeSizeOption {
    return SafeDepositBoxSafeSizeOptionFromJSONTyped(json, false);
}

export function SafeDepositBoxSafeSizeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeDepositBoxSafeSizeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'value': SafeSizeFromJSON(json['value']),
        'label': json['label'],
    };
}

export function SafeDepositBoxSafeSizeOptionToJSON(json: any): SafeDepositBoxSafeSizeOption {
    return SafeDepositBoxSafeSizeOptionToJSONTyped(json, false);
}

export function SafeDepositBoxSafeSizeOptionToJSONTyped(value?: SafeDepositBoxSafeSizeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': SafeSizeToJSON(value['value']),
        'label': value['label'],
    };
}

